/**
 * @param {number} discount - The discount value to check.
 * @returns {boolean} - Returns true if the discount is a positive number greater than 0, false otherwise.
 * It is used to determine if a product has a valid discount.
 * Useful for conditionally rendering discounted price UIs.
 * // Example usage:
 * const discount = 20;
 * const result = hasDiscount(discount);
 * console.log(result); // Output: true
 */

const hasDiscount = (discount) => typeof discount === "number" && discount > 0;

export default hasDiscount;
